import React, { useState } from "react";
import { Button } from "@vapor/react-material/Button";
import { Drawer } from "@vapor/react-material/Drawer";
import { Box } from "@vapor/react-material/Box";
import { Search } from "@vapor/react-icons/Search";
import { Card } from "@vapor/react-material/Card";
import { CardContent } from "@vapor/react-material/CardContent";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Chip } from "@vapor/react-material/Chip";
import TextField from "@vapor/react-material/TextField";
import  Stack  from "@vapor/react-material/Stack";
import { VaporIcon } from "@vapor/react-icons/VaporIcon";
import { faClockRotateLeft } from "@fortawesome/pro-regular-svg-icons";
import { dummyData4, chips } from "../../../../assets/DummyData.tsx";
import { useDrawerStore } from "../../../../context/DrawerContext/index.ts";

interface DrawerProps {
  drawerName: string;
}

export const RecentiComponent: React.FC<DrawerProps> = ({ drawerName }) => {
  console.log({ drawerName });
  const { open, setOpen } = useDrawerStore();
  const [chipState, setChipState] = useState<string>("Tutti");

  const setSelectedChip = (selectedChip: string) => {
    setChipState(selectedChip);
  };

  const handleDrawer = () => {
    setOpen(open === drawerName ? null : drawerName);
  };

  return (
    <div>
      <Button
        onClick={handleDrawer}
        sx={{
          "&:hover": {
            backgroundColor: "#008FD6",
          },
          backgroundColor: open === drawerName ? "#14A8E8" : "inherit",
        }}
      >
        <VaporIcon icon={faClockRotateLeft} color="inverse" />
      </Button>
      <Box>
        <Drawer
          anchor="right"
          open={open === drawerName}
          width={500}
          onClose={handleDrawer}
        >
          <Box marginTop="3rem">
            <CardContent>
              <Box display="flex" justifyContent="space-between">
                <Typography>Recenti (20)</Typography>
              </Box>
            </CardContent>
          </Box>
          <Box>
            <Card
              sx={{
                height: 120,
              }}
            >
              <CardContent>
                <Stack alignItems="end" direction="row">
                  <TextField
                    id="outlined-textarea"
                    multiline
                    placeholder="Cerca tra preferiti"
                    fullWidth
                  />
                  <Button variant="contained">
                    <Search />
                  </Button>
                </Stack>
                <Box>
                  <Stack
                    sx={{
                      overflow: "auto",
                      "&::-webkit-scrollbar": {
                        width: "0 !important ",
                      },
                    }}
                    direction="row"
                    spacing={1}
                    marginTop="12px"
                  >
                    {chips.map((chip) => (
                      <Chip
                        key={chip.index}
                        avatar={chip.icon}
                        label={chip.title}
                        clickable
                        variant={
                          chipState === chip.title ? "outlined" : "filled"
                        }
                        onClick={() => setSelectedChip(chip.title)}
                      />
                    ))}
                  </Stack>
                </Box>
              </CardContent>
            </Card>
          </Box>
          <Box>
            {dummyData4.map((data) => (
              <div key={data.id}>
                <Card
                  style={{
                    height: 70,
                  }}
                >
                  <CardContent>
                    <Box display="flex" justifyContent="space-between">
                      <Box marginTop="12px">{data.logo}</Box>
                      <Typography marginRight="20.5rem">
                        <strong>{data.title}</strong>
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        fontSize="12px"
                        marginTop="-18px"
                        marginLeft="2.3rem"
                      >
                        {data.content}
                      </Typography>
                      <Typography marginTop="-32px" fontSize="12px">
                        {data.time}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </div>
            ))}
          </Box>
        </Drawer>
      </Box>
    </div>
  );
};
